const pre = '/setting/';

export default {
    path: '/setting',
    title: '个人中心',
    header: '',
    icon: 'md-cog',
    auth: ['hidden'],
    children: [
        {
            path: `${pre}self`,
            title: '个人中心'
        }
    ]
}
